import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'lum-channel-form-fees',
  templateUrl: './channel-form-fees.component.html',
  styleUrls: ['./channel-form-fees.component.scss'],
})
export class ChannelFormFeesComponent implements OnInit {
  @Input() formData :UntypedFormGroup;

  public feeTypes :{ id :number; type :string }[] = [
    { id: 1, type: 'Fixed Amount' },
    { id: 2, type: '% of SRP' },
    { id: 5, type: '% of Material Cost' },
  ];

  constructor(private fb :UntypedFormBuilder) {}

  ngOnInit() :void {}

  get channelFees() :UntypedFormArray {
    return this.formData.get('fees') as UntypedFormArray;
  }

  onRemoveFees(idx :number) {
    this.channelFees.removeAt(idx);
  }

  onAddFee() {
    const fees :UntypedFormArray = this.formData.get('fees') as UntypedFormArray;
    const row :UntypedFormGroup = this.fb.group({
      label: ['', Validators.required],
      amount: [0, Validators.required],
      type: [2, Validators.required],
    });
    fees.push(row);
  }
}
